import Swal from 'sweetalert2';

/** SweetAlert2 themed like PHP popup.png parchment scroll */
export function sopFire(options = {}) {
  const { text, title = '', html, icon, customClass, confirmButtonText, ...rest } = options;
  return Swal.fire({
    title: title || undefined,
    text: text || undefined,
    html: html || undefined,
    confirmButtonText: confirmButtonText || 'OK',
    buttonsStyling: false,
    showCloseButton: false,
    allowOutsideClick: false,
    customClass: {
      popup: 'sop-swal-popup',
      title: 'sop-swal-title',
      htmlContainer: 'sop-swal-html',
      confirmButton: 'sop-swal-confirm',
      actions: 'sop-swal-actions',
      ...(customClass || {}),
    },
    ...rest,
    icon: undefined,
  });
}
